import { Routes } from '@angular/router';
import { CommitmentComponent } from './commitment.component';
import { HrPoliciesComponent } from './hr-policies/hr-policies.component';
import { JoinUsComponent } from './join-us/join-us.component';
import { OurValuesComponent } from './our-values/our-values.component';
import { SocialEnvironmentComponent } from './social-environment/social-environment.component';

export const routes: Routes = [
  {
    path: '',
    title: 'commitment',
    pathMatch: 'full',
    component: CommitmentComponent,
  },
  {
    path: 'nous-rejoindre',
    title: 'joinUs',
    component: JoinUsComponent,
  },
  {
    path: 'nos-valeurs',
    title: 'ourValues',
    component: OurValuesComponent,
  },
  {
    path: 'politiques-rh',
    title: 'hrPolicies',
    component: HrPoliciesComponent,
  },
  {
    path: 'social-environment',
    title: 'socialEnvironment',
    component: SocialEnvironmentComponent,
  },
]
